<template>
  <div>
    <header>
      <!-- main header section -->
      <div class="main-section">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="header-section">
                <!-- header left part -->
                <div class="menu-left">
                  <!-- brand logo -->
                  <a href="javascrip:void(0)" class="brand-logo">
                    <!-- <svg width="125" height="40" fill="none">
                      <use xlink:href="#brandLogo" />
                    </svg> -->
                  </a>
                  <!-- navbar start-->
                  <nav class="navbar navbar-expand-lg navbar-light">
                    <button class="navbar-toggler" type="button">
                      <img src="/images/bars.png" />
                    </button>
                    <a href="javascript:void(0)" class="menu_overlay"></a>
                    <div class="navbar-collapse">
                      <ul class="navbar-nav">
                        <li class="nav-item">
                          <div class="menu-item"></div>
                        </li>
                        <li class="nav-item">
                          <div class="menu-item"></div>
                        </li>
                        <li class="nav-item">
                          <div class="menu-item"></div>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>
                <!-- header right part-->
                <ul class="menu-right">
                  <li class="cart-section">
                    <svg width="24" height="24" fill="none">
                      <use xlink:href="#cart" />
                    </svg>
                    <!-- <span class="count">6</span> -->
                  </li>
                  <!-- <li class="header-buttons d-none d-md-block">
                    <a href="login.html" class="btn btn-solid">Login</a>
                  </li> -->
                  <li class="login-profile language-select d-block">
                    <div class="select-title">
                      <div class="profile-img">
                        <a href="javascript:void(0)">
                          <img
                            src="/images/dummy-img.png"
                            class="img-fluid bg-img"
                            alt=""
                          />
                        </a>
                      </div>
                      <div class="profile-detail">
                        <a href="javascript:void(0)" class="profile-name">
                          <h6 class="ldr-text"></h6>
                        </a>
                        <div class="profile-balance ldr-profile-balance"></div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: 'SkeletonLoaderHeader',
}
</script>

<style lang="scss" scoped>
header {
  .main-section {
    .profile-detail {
      .ldr-text {
        width: $px40;
        height: $px20;
        background: #eef0f5
          linear-gradient(90deg, #eef0f5 0px, #f3f3f3 40px, #eef0f5 80px);
        background-size: $px600;
        animation: shine-avatar 1.6s infinite linear;
      }
      .ldr-profile-balance {
        width: $px80;
        height: $px18;
        background: #eef0f5
          linear-gradient(90deg, #eef0f5 0px, #f3f3f3 40px, #eef0f5 80px);
        background-size: $px600;
        animation: shine-avatar 1.6s infinite linear;
      }
    }
  }
}
.navbar-toggler {
  display: none;
  padding-left: 0;
  padding-right: 0;
  border: none;
  img {
    width: $px20;
  }
}
.header-section {
  padding: $px22 0;
  display: flex;
  align-items: center;
  .navbar-toggler {
    padding-left: 0;
    padding-right: 0;
    border: none;
  }
  .menu-left {
    display: flex;
    .brand-logo {
      margin-right: $px30;
      background-color: $grey-2;
      width: $px125;
      height: $px40;
      &.center-logo {
        position: absolute;
        margin-right: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .navbar {
      padding: 0;
      .menu_overlay {
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(black, 0.5);
        z-index: 2;
        display: none;
        &.show {
          display: block;
        }
      }
      .navbar-nav {
        .nav-item {
          font-size: $px16;
          text-transform: capitalize;
          .menu-item {
            width: $px100;
            min-height: $px35;
            height: $px18;
            background: #eef0f5
              linear-gradient(90deg, #eef0f5 0px, #f3f3f3 40px, #eef0f5 80px);
            background-size: $px600;
            animation: shine-avatar 1.6s infinite linear;
            margin-right: $px10;
          }
        }
      }
    }
  }
  .menu-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    li {
      position: relative;
      padding-left: $px24;
      padding-right: $px24;
      &:first-child {
        padding-left: 0;
        &:after {
          display: none;
        }
      }
      &:last-child {
        padding-right: 0;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        height: $px30;
        width: $px1;
        background-color: $light-border;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .language-select {
      position: relative;
      .select-title {
        line-height: $px18;
        color: $font-color;
        text-transform: capitalize;
        font-weight: 600;
        cursor: pointer;
        margin-bottom: 0;
        font-size: $px16;
      }
      .language-dropdown {
        position: absolute;
        top: $px12;
        right: 0;
        background-color: white;
        width: $px170;
        box-shadow: 0 $px3 $px15 rgba(0, 0, 0, 0.1);
        padding: $px12 $px5;
        opacity: 0;
        visibility: hidden;
        transition: all 0.5s ease;
        z-index: 1;
        li {
          display: flex;
          align-items: center;
          padding: $px8 $px10;
          border-radius: $px2;
          cursor: pointer;
          transition: all 0.5s ease;
          img,
          svg {
            width: $px18;
            margin-right: $px15;
          }
          &:after {
            display: none;
          }
          h4 {
            margin-bottom: 0;
            text-transform: capitalize;
            font-weight: 500;
            font-size: $px16;
          }
          &.active {
            h4 {
              color: $color-primary;
              transition: all 0.5s ease;
              font-weight: 600;
            }
          }
          &:hover {
            background: $color-primary;
            color: $white;
            transition: all 0.5s ease;
          }
        }
        &.open {
          opacity: 1;
          visibility: visible;
          top: $px30;
          transition: all 0.5s ease;
        }
      }
      &.country-select {
        .select-title {
          img {
            width: $px24;
            height: $px24;
            border-radius: 100%;
          }
        }
      }
    }
    .cart-section {
      position: relative;
      @extend %default-scroll;
      img {
        cursor: pointer;
      }
      .count {
        position: absolute;
        font-size: $px12;
        line-height: $px15;
        background-color: $primary-color;
        padding: $px2 $px6;
        border-radius: 100%;
        color: white;
        right: $px12;
        top: -$px8;
      }
      .mini-cart {
        .cart-box {
          opacity: 0;
          visibility: hidden;
          position: absolute;
          background: $white;
          box-shadow: 0 $px8 $px30 rgba(0, 0, 0, 0.25);
          border-radius: $px30;
          width: $px375;
          z-index: 4;
          left: -$px80;
          top: $px44;
          .cart-title {
            padding: $px20;
            border-bottom: $px1 solid $light-border;
            h5 {
              margin-bottom: 0;
              letter-spacing: 0.005em;
              color: $font-color;
              text-transform: capitalize;
              font-weight: 600;
              span {
                font-weight: 400;
              }
            }
          }
          .cart-details {
            padding: 0 $px20;
            position: relative;
            max-height: $px280;
            overflow: auto;
            li {
              width: 100%;
              padding: $px20 0;
              border-bottom: $px1 solid $light-border;
              &:after {
                display: none;
              }
              &:last-child {
                border-bottom: none;
              }
            }
            h5 {
              font-size: $px14;
              line-height: $px17;
              font-weight: 600;
              margin-bottom: $px5;
              text-transform: capitalize;
            }
            .inner-details {
              text-transform: capitalize;
              width: $px270;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: $px10;
              li {
                padding: 0 0 0 $px8;
                margin-left: $px5;
                position: relative;
                border-bottom: none;
                width: auto;
                &:first-child {
                  margin-left: 0;
                  &:after {
                    display: block;
                  }
                }
                &:after {
                  display: block;
                  position: absolute;
                  width: $px4;
                  height: $px4;
                  border-radius: 100%;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  background: $warning-color;
                }
              }
            }
            .cart-price {
              display: flex;
              align-items: center;
              margin-bottom: -$px4;
              h6 {
                margin-bottom: 0;
                margin-right: $px3;
                text-transform: uppercase;
                line-height: $px17;
                letter-spacing: 0.5px;
                color: var(--primary-color);
                font-weight: 500;
                span {
                  font-weight: 600;
                }
              }
              .price-info {
                position: relative;
                img {
                  margin-bottom: $px3;
                  margin-left: $px2;
                  cursor: pointer;
                }
                .price-info-box {
                  position: absolute;
                  left: -$px10;
                  top: $px16;
                  opacity: 0;
                  width: $px240;
                  box-shadow: 0 3.48882px 8.72204px rgba(0, 0, 0, 0.1);
                  border-radius: $px4;
                  background: #ffffff;
                  padding: $px5 $px8;
                  h6 {
                    font-size: $px10;
                    font-weight: 400;
                    margin-right: 0;
                    color: $font-color;
                    text-transform: capitalize;
                    letter-spacing: 0.01em;
                    span {
                      color: var(--primary-color);
                    }
                  }
                }
                &:hover {
                  .price-info-box {
                    opacity: 1;
                  }
                }
              }
            }
            .cart-trash {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: $px40;
              height: $px40;
              border-radius: $px4;
              background-color: var(--primary-color-1);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .cart-checkout {
            padding: $px15;
            border-top: $px1 solid $light-border;
            .btn {
              text-transform: capitalize;
            }
          }
          &.open {
            opacity: 1;
            visibility: visible;
          }
        }
        .cart-design {
          position: absolute;
          top: $px30;
          z-index: 5;
        }
      }
    }
    .notification-bar {
      display: none;
    }
    .header-buttons {
      display: flex;
      .btn {
        height: $px40;
        width: $px100;
        padding: 0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        + .btn {
          margin-left: $px10;
          margin-right: $px10;
        }
      }
    }
    .login-profile {
      display: flex;
      align-items: center;
      .select-title {
        display: flex;
        align-items: center;
      }
      .language-dropdown {
        top: $px40;
        li {
          a {
            h4 {
              transition: 0.3s ease;
            }
          }
          &:hover {
            background-color: transparent;
            a {
              h4 {
                color: $color-primary;
                transition: 0.3s ease;
              }
            }
          }
        }
        &.open {
          top: $px50;
        }
      }
      .profile-img {
        margin-right: $px12;
        position: relative;
        .bg-size,
        img {
          width: $px40;
          height: $px40;
          border-radius: 100%;
          border: $px2 solid $light-border;
        }
        &:after {
          content: '';
          position: absolute;
          width: $px8;
          height: $px8;
          border-radius: 100%;
          background-color: var(--primary-color);
          right: $px3;
          top: $px3;
        }
      }
      .profile-detail {
        .profile-name {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          h6 {
            line-height: $px19;
            color: $font-color;
            font-weight: 500;
            margin-bottom: 0;
            margin-right: $px8;
          }
        }
        .profile-balance {
          display: flex;
          align-items: center;
          margin-top: $px6;
          img {
            margin-right: $px6;
          }
          span {
            font-size: $px12;
            line-height: $px17;
            letter-spacing: 0.583333px;
            color: var(--primary-color);
            text-transform: uppercase;
            font-weight: 500;
          }
        }
      }
    }
    .location {
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        width: $px36;
        height: auto;
      }
      h4 {
        font-size: $px16;
        margin-bottom: -$px2;
        //text-overflow: ellipsis;
        margin-left: $px8;
        font-weight: 700;
      }
    }
  }
}
@media (max-width: 991px) {
  .navbar-collapse {
    display: none;
  }
  .navbar-toggler {
    display: block;
  }
}
@media (max-width: 575px) {
  header {
    .main-section {
      .menu-right {
        li {
          &:after {
            left: 65%;
          }
        }
        .cart-section {
          display: none;
        }
        .profile-img {
          margin-right: $px22 !important;
          a {
            width: $px40;
            height: $px20;
            background: #eef0f5
              linear-gradient(90deg, #eef0f5 0px, #f3f3f3 40px, #eef0f5 80px);
            background-size: $px600;
            animation: shine-avatar 1.6s infinite linear;
            display: flex;
            img {
              display: none;
            }
          }
        }
        .profile-name {
          .ldr-text {
            width: $px30;
            height: $px30;
            border-radius: 50%;
            margin: 0 !important;
          }
        }
        .profile-balance {
          display: none !important;
        }
      }
    }
  }
}
.body-rtl {
  .login-profile {
    .language-dropdown.open {
      text-align: right;
    }
  }
  .profile-detail {
    .profile-name {
      h6 {
        margin-left: 0.5rem;
        margin-right: unset;
      }
    }
    .profile-balance {
      svg {
        margin-right: unset;
        margin-left: 0.375rem;
      }
    }
  }
  .header-section {
    .menu-right {
      margin-left: unset;
      margin-right: auto;
      ul {
        padding-left: unset;
        padding-right: 0;
      }
    }
  }
}
</style>
